export default __webpack_public_path__ + "static/media/Large_Logo.92237ade.svg";